import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Views/Home";
import Search from "./Views/Search";
import About from "./Views/About";
import Login from "./Views/Login";
import Signup from "./Views/Signup";
import Dashboard from "./Views/Dashboard";
import Footer from "./Components/Footer";
import Nft from "./Components/Nft";
import Seller from "./Components/Seller";
import ScrollToTop from "./Components/ScrollToTop";
import PrivateRoute from "./Components/PrivateRoute";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div
        style={{ backgroundColor: "#FBFDFF" }}
        className="font-poppins m-0 p-0 border-box bg-center bg-cover bg-fixed"
      >
        <Header />

        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/search" exact component={Search} />
          <Route path="/about" component={About} />
          <Route path="/nft/:id" component={Nft} />
          <Route path="/seller/:id" component={Seller} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <PrivateRoute path="/dashboard" component={Dashboard} exact />
          <Route path="*" component={() => "404 NOT FOUND"} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
